import { orchestrator } from 'satcheljs';
import { addGenericLinkClickListener } from '../actions/internalActions';
import { OD_LINK_CLICK_EVENT_LISTENER, OD_LINK_MOUSEUP_EVENT_LISTENER } from '../utils/constants';
import documentLinkMouseUpHandler from '../utils/documentLinkMouseUpHandler';
import serviceGeneratedLinkClickHandler from '../utils/serviceGeneratedLinkClickHandler';

orchestrator(addGenericLinkClickListener, actionMessage => {
    const { element, isSafeLinkWrapped, isSafeLinkVerified } = actionMessage;
    const eventListener = (ev: MouseEvent) => {
        serviceGeneratedLinkClickHandler(
            ev,
            isSafeLinkWrapped,
            isSafeLinkVerified,
            null /* newTabReason */
        );
    };
    element.addEventListener('click', eventListener);
    element[OD_LINK_CLICK_EVENT_LISTENER] = eventListener;

    const mouseupListener = (ev: MouseEvent) => {
        documentLinkMouseUpHandler(ev, isSafeLinkWrapped, isSafeLinkVerified);
    };
    element.addEventListener('mouseup', mouseupListener);
    element[OD_LINK_MOUSEUP_EVENT_LISTENER] = mouseupListener;
});
